import { render, staticRenderFns } from "./coverage_new.vue?vue&type=template&id=3a27dafc&"
import script from "./coverage_new.vue?vue&type=script&lang=js&"
export * from "./coverage_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports